import React, { useState, useEffect } from "react";
import { MenuItem, Select, TextField, Button, Box } from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TableView from "../../../CustomComponent/TableView";
import QuestionListHead from "./QuestionListHead";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

function AddFeedbackMarks({ changeTab }) {
  const classes = useStyles();
  const isMounted = React.useRef(true);
  const previousPageRef = React.useRef(0);
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  const { state } = useLocation();
  const total_score = state;
  const [pageSize, setPageSize] = useState(25);
  const [page, setPage] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [marksCache, setMarksCache] = useState({});

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const style = [
    {
      height: "h57vh",
      style: "viewtable",
      footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      handlePageChange: handlePageChange,
      page: page,
      rowCount: rowCount,
      paginationMode: "server",
    },
  ];
  const { rowId } = useParams();
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();

  const [questions, setQuestions] = useState([]);
  const [examName, setExamName] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;

  const fetchAllQuestionsForCache = async () => {
    if (!rowId || !decryptedToken) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/mark/by_exam/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      if (isMounted.current) {
        const cache = {};
        response.data.questions.forEach((q) => {
          cache[q.id] = {
            id: q.id,
            exam_id: q.exam_id,
            mark: q.mark || "",
            partial_mark: q.partial_mark || "",
            negative_marking: q.negative_marking || "",
            negative_mark: q.negative_mark || "",
            q_prifix: q.q_prifix,
            question_type: q.question_type,
          };
        });
        setMarksCache((prev) => ({ ...cache, ...prev }));
      }
    } catch (error) {
      if (isMounted.current) {
        console.error("Error fetching all questions for cache: ", error);
      }
    }
  };

  const fetchData = async () => {
    if (!rowId || !decryptedToken) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/mark/by_exam/${rowId}?page=${page + 1}&limit=${pageSize}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      if (isMounted.current) {
        setQuestions(response.data.questions);
        setRowCount(response?.data?.count || response?.data?.questions?.length || 0);
        previousPageRef.current = page;
        console.log("questions12345", response.data.questions);
      }
    } catch (error) {
      if (isMounted.current) {
        toast.error("Failed to fetch questions. Reverting page...");
        setPage(previousPageRef.current);
        console.error("Error fetching data: ", error);
      }
    }
  };

  useEffect(() => {
    if (rowId && decryptedToken) {
      setMarksCache({});
      fetchAllQuestionsForCache();
    }
  }, [rowId]);

  useEffect(() => {
    fetchData();
  }, [rowId, page, pageSize]);

  const handleFieldChange = (id, field, value) => {
    setQuestions((prevQuestions) =>
      prevQuestions.map((question) =>
        question.id === id ? { ...question, [field]: value } : question
      )
    );
    setMarksCache((prevCache) => ({
      ...prevCache,
      [id]: {
        ...prevCache[id],
        [field]: value,
      },
    }));
  };

  const handleSave = async () => {
    const newQuestion = Object.entries(marksCache).map(([id, question]) => {
      return {
        id: id,
        exam_id: question.exam_id,
        mark: question.mark,
        partial_mark: question.partial_mark,
        negative_marking: question.negative_marking,
        negative_mark:
          question.negative_mark < 0
            ? question.negative_mark
            : -Math.abs(question.negative_mark),
      };
    });

    const totalMarks = newQuestion.reduce(
      (acc, curr) => acc + Number(curr.mark || 0),
      0
    );

    if (totalMarks !== Number(total_score)) {
      toast.error(
        `Total marks (${totalMarks}) must be equal to Total Score (${total_score})`
      );
      return;
    }

    const data = {
      questions: [...newQuestion],
    };
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/mark/update`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      toast.success("Marks updated successfully!");
      fetchData(); // Refresh the data
      navigate("/admin/feedback");
    } catch (error) {
      console.error("Error updating marks: ", error);
      toast.error("Failed to update marks. Please try again.");
    }
  };

  const columns = [
    {
      field: "question_no",
      headerName: "Question No",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 120,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "question_type",
      headerName: "Question Type",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "marks",
      headerName: "Marks",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => {
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <TextField
              onChange={(e) =>
                handleFieldChange(cellValues.row.id, "mark", e.target.value)
              }
              value={cellValues.row.mark || ""}
              type="number"
              variant="outlined"
              required
              placeholder="Enter Marks"
              onWheel={(e) => e.target.blur()}
            />
          </div>
        );
      },
    },
    {
      field: "partial_marks",
      headerName: "Partial Marks",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => {
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <TextField
              onChange={(e) =>
                handleFieldChange(
                  cellValues.row.id,
                  "partial_mark",
                  e.target.value
                )
              }
              value={cellValues.row.partial_mark || ""}
              type="number"
              variant="outlined"
              required
              placeholder="Enter Partial Marks"
              disabled={cellValues.row.question_type !== "Multiple Choice"}
              onWheel={(e) => e.target.blur()}
            />
          </div>
        );
      },
    },
    {
      field: "negative_marking",
      headerName: "Negative Marking",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => {
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <Select
              labelId="negative-marking-label"
              style={{ width: "100px" }}
              id="negative_marking"
              value={cellValues.row.negative_marking || ""}
              onChange={(e) =>
                handleFieldChange(
                  cellValues.row.id,
                  "negative_marking",
                  e.target.value
                )
              }
              displayEmpty
              className={classes.selectEmpty}
              variant="outlined"
            >
              <MenuItem disabled value="">
                Select Option
              </MenuItem>
              <MenuItem value="yes">Yes</MenuItem>
              <MenuItem value="no">No</MenuItem>
            </Select>
          </div>
        );
      },
    },
    {
      field: "negative_mark",
      headerName: "Negative Mark",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => {
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <TextField
              onChange={(e) => {
                let value = e.target.value;

                // Allow only digits (no dots, no negative signs)
                value = value.replace(/[^0-9.]/g, "");
                handleFieldChange(cellValues.row.id, "negative_mark", value);
              }}
              value={
                cellValues.row.negative_mark
                  ? `-${String(cellValues.row.negative_mark).replace(
                      /^[-]+/,
                      ""
                    )}`
                  : ""
              }
              type="text"
              variant="outlined"
              required
              placeholder="Enter Negative Mark"
              disabled={cellValues.row.negative_marking !== "yes"}
              onWheel={(e) => e.target.blur()}
            />
          </div>
        );
      },
    },
  ];

  const rows = questions.map((d, index) => {
    const cached = marksCache[d.id] || {};
    return {
      id: d.id || "N/A",
      exam_id: d.exam_id || "N/A",
      question_no: d.q_prifix || "N/A",
      question_type: d.question_type || "N/A",
      mark: cached.mark !== undefined ? cached.mark : (d.mark || ""),
      partial_mark: cached.partial_mark !== undefined ? cached.partial_mark : (d.partial_mark || ""),
      negative_marking: cached.negative_marking !== undefined ? cached.negative_marking : (d.negative_marking || ""),
      negative_mark: cached.negative_mark !== undefined ? cached.negative_mark : (d.negative_mark || ""),
      active_status: d.active_status ? d.active_status : "N/A",
    };
  });

  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.mt1} ${classes.bgwhite} ${classes.inputpadding} ${classes.inputborder}`}
      >
        <QuestionListHead
          questionList={true}
          fetchData={fetchData}
          examName={examName}
        />

        <TableView columns={columns} rows={rows} Heading={style} />

        <Box
          style={{
            display: "flex",
            justifyContent: "end",
            marginTop: "10px",
            gap: "10px",
          }}
        >
          <Button
            variant="outlined"
            onClick={() => navigate("/admin/feedback")}
            className={classes.mr2}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            onClick={handleSave}
            className={`${classes.custombtnblue}`}
          >
            {"Save Changes"}
          </Button>
        </Box>
      </div>
    </>
  );
}

export default AddFeedbackMarks;
